"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("../Button"));
var styles_1 = require("./styles");
var react_i18next_1 = require("react-i18next");
var useLayoutLinks_1 = require("./hooks/useLayoutLinks");
var SecondaryButtons = function (_a) {
    var links = _a.links, handleNavigation = _a.handleNavigation, layoutLoading = _a.layoutLoading, headerView = _a.headerView, newTabProps = _a.newTabProps;
    var t = (0, react_i18next_1.useTranslation)().t;
    if (layoutLoading) {
        return react_1.default.createElement(styles_1.StyledSkeleton, null);
    }
    return (react_1.default.createElement(react_1.default.Fragment, null, headerView &&
        links.map(function (_a) {
            var id = _a.id, translationString = _a.translationString, url = _a.url;
            return (react_1.default.createElement(Button_1.default, __assign({ key: id, disableRipple: true, sx: styles_1.buttonFocusOverride, className: "fs-unmask", component: "a", variant: "text", "data-testid": "".concat(translationString, "-link"), href: url, onClick: handleNavigation(url) }, (id === useLayoutLinks_1.SecondaryLinks.Admin && newTabProps)), t("prism-header:".concat(translationString))));
        })));
};
exports.default = SecondaryButtons;
//# sourceMappingURL=SecondaryButtons.js.map